import CircularProgress from "@mui/material/CircularProgress";
import "./index.scss";

export const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="loading-screen">
      <div className="loading-wrapper">
        <CircularProgress sx={{ color: "#f59e0b" }} size={48} thickness={4} />
        <p className="loading-text" suppressHydrationWarning>{message}</p>
      </div>
    </div>
  );
};
